"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

const BTN =
  "inline-flex h-[30px] items-center gap-1.5 rounded-(--r-full) border border-border bg-surface px-3 text-[12px] font-semibold text-secondary transition-colors hover:border-(--ink-40) hover:text-body";

function XIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-3.5 w-3.5"
      role="img"
      aria-label="X"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231z" />
    </svg>
  );
}

export function ShareButtons({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const shareOnX = () => {
    const url = window.location.href;
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const copyLink = async () => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("utm_source", "copy_link");
      url.searchParams.set("utm_medium", "blog_share");
      url.searchParams.set("utm_campaign", "blog");
      await navigator.clipboard.writeText(url.toString());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard can be unavailable (e.g. insecure context); no-op.
    }
  };

  return (
    <div className="ml-auto flex items-center gap-2">
      <button type="button" onClick={shareOnX} className={BTN}>
        <XIcon />
        Share
      </button>
      <button type="button" onClick={copyLink} className={BTN}>
        {copied ? (
          <Check className="h-3.5 w-3.5" aria-hidden />
        ) : (
          <Copy className="h-3.5 w-3.5" aria-hidden />
        )}
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
